import { defineSetting } from '../settingsRegistry';

declare module '../settingsRegistry' {
  interface Settings {
    /** Drifting mist and falling petals (and the ground's glints, the swaying grass, the spots' dressing). */
    ambience: boolean;
  }
}

defineSetting({
  key: 'ambience',
  default: true,
  order: 90,
  menu: { group: 'visual', label: 'หมอกและกลีบดอกไม้' },
});
